import React from "react";
import { Chart } from "react-google-charts";


export const ViewsChart = ({ barChartData }) => {
    let barChartDataArray = [["", "Viewed", "Assigned",]];

    barChartData && Object.keys(barChartData).map(key => {
        if(barChartData[key].assigned != null && barChartData[key].viewed != null) {
            barChartDataArray.push([key, barChartData[key].viewed, barChartData[key].assigned]);
        }
    });

    const options = {
        // bar: { groupWidth: "20%" },
        colors: ['#2F80ED', '#219653'],
        legend: { position: "none" },
        vAxis: {
            minValue: 0,
        },
    };

    return (
        <div className="p-2 mt-2">
            { 
                barChartDataArray.length > 1 ?
                    <Chart
                        chartType="Bar"
                        width="full"
                        height="100%"
                        data={ barChartDataArray }
                        options={ options }
                    />
                :
                    <p style={{ margin: 20, color: '#818181', fontSize: 14 }}>No details found for assignee wise notice views.</p>
            }
        </div>
    );
}
